import { useState, useEffect, Fragment } from "react";
import {
  Scheduler,
  AgendaView,
  TimelineView,
  DayView,
  WeekView,
  MonthView,
  WorkWeekView,
  SchedulerItem,
  SchedulerHeader,
  SchedulerFooter,
} from "@progress/kendo-react-scheduler";
import EventDateService from "../../services/srv-event/EventDateService";
import LoadingPanel from "../../components/sys-toolbox/LoadingPanel";
import {
  IntlProvider,
  loadMessages,
  LocalizationProvider,
} from "@progress/kendo-react-intl";
import i18n from "../../config/languageInit";
import { useSearchParams } from "react-router-dom";

function CompanySchedulerIntra(props) {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  loadMessages(i18n.store.data["tr"], "tr");

  useEffect(() => {
    getData();
  }, []);

  const validateParameters = (timestamp, signature) => {
    if (!timestamp || !signature) {
      return false;
    }
    // timestamp ve signature doğrulaması
    return true;
  };

  const getData = () => {
    const timestamp = searchParams.get("timestamp");
    const signature = searchParams.get("signature");

    if (!validateParameters(timestamp, signature)) {
      return;
    }

    setLoading(true);
    EventDateService.getListIntra(timestamp, signature).then((data) => {
      setLoading(false);
      setData(
        data.map((item) => {
          return {
            id: item.etkinliK_TARIH_ID,
            title: item.etkinliK_ADI,
            start: item.baS_TAR ? new Date(item.baS_TAR) : new Date(),
            end: item.biT_TAR ? new Date(item.biT_TAR) : new Date(),
            color: item.renK_KODU,
          };
        })
      );
    });
  };

  const CustomItem = (props) => {
    return (
      <SchedulerItem
        {...props}
        style={{
          ...props.style,
          backgroundColor: props.dataItem.color,
        }}
      />
    );
  };

  return (
    <Fragment>
      {loading && <LoadingPanel />}
      {data?.length > 0 && (
        <>
          <LocalizationProvider language={"tr"}>
            <IntlProvider locale={"tr"}>
              <Scheduler
                id="scheduler-intra"
                data={data}
                item={CustomItem}
                header={(props) => (
                  <SchedulerHeader
                    {...props}
                    style={{ backgroundColor: "white" }}
                  />
                )}
                footer={(props) => (
                  <SchedulerFooter
                    {...props}
                    style={{ backgroundColor: "white" }}
                  />
                )}
              >
                <AgendaView />
                <DayView />
                <WeekView />
                <MonthView />
                <WorkWeekView />
              </Scheduler>
            </IntlProvider>
          </LocalizationProvider>
        </>
      )}
    </Fragment>
  );
}

export { CompanySchedulerIntra };
